import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CheckboxField } from 'src/components/mui-overrides/Checkbox';
import { DefaultFastTextAreaField } from 'src/components/mui-overrides/Textarea';
import { DefaultFastTextField } from 'src/components/mui-overrides/Textfield';
import { LaunchpadCard } from 'src/components/ui/LaunchpadCard';
import { TwoColumnGridContainer } from 'src/components/ui/TwoColumnGridContainer';
import { ScenarioCalculationsUploader } from '../atomic-components/ScenarioCalculationsUploader';
import { useFormikContext } from 'formik';
import { TAssetInvestmentDetailsSchema } from '@brickwise/asset-validation/dist/asset/investmentData';

interface Props {
  disabled?: boolean;
}

export const ReturnOnEquityCalculation: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();
  const formik = useFormikContext<TAssetInvestmentDetailsSchema>();
  return (
    <LaunchpadCard title={t('dashboard.assets.addedit.investment.returnOnEquity.title')}>
      <TwoColumnGridContainer>
        <div>
          <CheckboxField
            label={t('dashboard.assets.addedit.main.investmentDetails.fields.returnOnEquityCalculation.label')}
            fieldName="investorSettings.calculateReturnOnEquity"
            disabled={disabled}
          />
          {!formik.values.investmentDetails?.maturityDate ? (
            <DefaultFastTextField
              disabled={disabled}
              label={t('dashboard.assets.addedit.main.investmentDetails.fields.fixedObservationPeriodInY.label')}
              fieldName="investorSettings.fixedObservationPeriodInY"
              type="number"
            />
          ) : null}
          <ScenarioCalculationsUploader disabled={disabled} />
        </div>
        <div>
          <DefaultFastTextAreaField
            disabled={disabled}
            label={t('dashboard.assets.addedit.main.investmentDetails.fields.distributionYieldText.label')}
            fieldName="investorSettings.distributionYieldText"
          />
          <DefaultFastTextAreaField
            disabled={disabled}
            label={t('dashboard.assets.addedit.main.investmentDetails.fields.returnOnEquityText.label')}
            fieldName="investorSettings.returnOnEquityText"
          />
          <DefaultFastTextAreaField
            disabled={disabled}
            label={t('dashboard.assets.addedit.main.investmentDetails.fields.assetValueDevelopment.label')}
            fieldName="investorSettings.assetValueDevelopmentText"
          />
        </div>
      </TwoColumnGridContainer>
    </LaunchpadCard>
  );
};
